export { default as StatusBar } from './StatusBar';
export type { StatusBarProps } from './types';
